import { format, startOfDay, endOfDay, startOfWeek, endOfWeek, subWeeks } from 'date-fns';
import axiosInstance from './axiosConfig';

/**
 * Fetches weekly spending data directly from the API
 * @returns {Promise<Object>} Object with amounts, labels, and transactions arrays
 */
export const fetchWeeklySpendingData = async () => {
  // Generate default week labels outside try/catch so they're available in case of error
  const defaultWeekLabels = [];
  const today = new Date();
  for (let i = 3; i >= 0; i--) {
    const weekEnd = endOfWeek(subWeeks(today, i), { weekStartsOn: 1 }); // 1 = Monday
    const weekStart = startOfWeek(weekEnd, { weekStartsOn: 1 });
    const startFormatted = format(weekStart, 'MMM d');
    const endFormatted = format(weekEnd, 'MMM d');
    defaultWeekLabels.push(`${startFormatted}-${endFormatted}`);
  }

  try {
    // Create arrays for the data
    const last4Weeks = Array(4).fill(0);
    const weekLabels = [];
    const weekRanges = [];
    const weekTransactions = Array(4).fill([]); // Store transactions for each week
    
    // Loop through the last 4 weeks
    for (let i = 3; i >= 0; i--) {
      // Calculate start and end dates for Monday-Sunday week
      const weekEnd = endOfWeek(subWeeks(today, i), { weekStartsOn: 1 }); // 1 = Monday
      const weekStart = startOfWeek(weekEnd, { weekStartsOn: 1 });
      
      // Format dates for display
      const startFormatted = format(weekStart, 'MMM d');
      const endFormatted = format(weekEnd, 'MMM d');
      weekLabels.push(`${startFormatted}-${endFormatted}`);
      
      // Store the date range for reference
      weekRanges.push({
        startDate: weekStart,
        endDate: weekEnd
      });
      
      // Set start to beginning of day and end to end of day
      const startDateTime = startOfDay(weekStart);
      const endDateTime = endOfDay(weekEnd);
      
      // Directly query API for transactions in this date range
      const response = await axiosInstance.get('/transactions', {
        params: {
          startDate: startDateTime.toISOString(),
          endDate: endDateTime.toISOString(),
          limit: 1000, // High limit to ensure we get all transactions
          sortBy: 'date',
          sortDirection: 'desc'
        }
      });
      
      // Store transactions for this week
      weekTransactions[3-i] = response.data.transactions;
      
      // Calculate total for this week from the response
      const totalAmount = response.data.transactions.reduce((sum, transaction) => 
        sum + transaction.amount, 0);
      
      // Store in our array
      last4Weeks[3-i] = totalAmount;
    }
    
    return {
      amounts: last4Weeks,
      labels: weekLabels,
      weekRanges: weekRanges,
      transactions: weekTransactions,
      hasTransactions: true
    };
  } catch (err) {
    console.error("Error fetching weekly spending data:", err);
    // Return mock data in case of error
    return {
      amounts: [520, 485, 630, 540],
      labels: defaultWeekLabels,
      weekRanges: [],
      transactions: Array(4).fill([]),
      hasTransactions: false
    };
  }
}; 